 // src/utils/speech.js
// src/utils/speech.js

/**
 * 语音合成函数（增强版）
 * @param {string} text - 要朗读的文本
 * @param {string} [lang='zh-CN'] - 语言代码
 * @param {number} [rate=0.7] - 语速 (0.1-10)
 * @param {number} [pitch=1] - 音高 (0-2)
 */
// 修改后的 speak 函数
export function speak(text, lang = 'zh-CN', rate = 0.7, pitch = 1) {
  if (!text || typeof text !== 'string') return;

  // 1. 优先使用 H5+ 原生语音
  if (window.plus && plus.speech) {
      try {
          plus.speech.speak(text, {
              volume: 1.0,
              rate: rate
          }, function() {
              console.log('H5+语音播报成功');
          }, function(e) {
              console.error('H5+语音播报失败:', e);
              fallbackToWebSpeech(text, lang, rate, pitch);
          });
          return;
      } catch (e) {
          console.error('H5+语音异常:', e);
          fallbackToWebSpeech(text, lang, rate, pitch);
      }
  } else {
      fallbackToWebSpeech(text, lang, rate, pitch);
  }
}

// 备用方案：Web Speech API
function fallbackToWebSpeech(text, lang, rate, pitch) {
  if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = lang;
      utterance.rate = Math.min(Math.max(rate, 0.1), 10);
      utterance.pitch = Math.min(Math.max(pitch, 0), 2);
      
      // 解决Android上可能不工作的问题
      utterance.onerror = (e) => {
          console.error('Web Speech错误:', e);
          // 最后尝试使用Android原生TTS
          if (window.android && window.android.ttsSpeak) {
              window.android.ttsSpeak(text);
          }
      };
      
      window.speechSynthesis.speak(utterance);
  } else if (window.TTS) {
      // Cordova TTS插件
      window.TTS.speak({ text, locale: lang, rate });
  } else {
      console.warn('无可用语音引擎');
  }
}




// WEBPACK FOOTER //
// ./src/utils/speech.js